import { render, staticRenderFns } from "./AtalhoDropdownBtn.vue?vue&type=template&id=59ce8007&scoped=true"
import script from "./AtalhoDropdownBtn.vue?vue&type=script&lang=js"
export * from "./AtalhoDropdownBtn.vue?vue&type=script&lang=js"
import style0 from "./AtalhoDropdownBtn.vue?vue&type=style&index=0&id=59ce8007&prod&scoped=true&lang=css"
import style1 from "./AtalhoDropdownBtn.vue?vue&type=style&index=1&id=59ce8007&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ce8007",
  null
  
)

export default component.exports